// The site-wide bibliography, read by everyone and saved whole by the admin.
// Also read by a chapter's citation editor, to link a citation to an entry.
import type { BibliographyEntryInput, BibliographyEntryView, BibliographyInput } from "@bibleunleashed/shared";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api, put } from "./api";

const KEY = ["bibliography"];

/**
 * "Heiser, Michael S. The Unseen Realm. Lexham Press. 2015."
 * Authors are stored surname-first and so already end in a stop; adding
 * another would give "Heiser, Michael S..".
 */
export function formatBibliographyEntry(e: BibliographyEntryInput): string {
  const bits = [e.author, e.title, e.extra ?? "", e.year ? String(e.year) : ""].map((b) => b.trim()).filter(Boolean);
  return bits.map((b) => (/[.?!]$/.test(b) ? b : `${b}.`)).join(" ");
}

export function useBibliography() {
  return useQuery({ queryKey: KEY, queryFn: () => api<BibliographyEntryView[]>("/api/bibliography"), staleTime: 5 * 60_000 });
}

export function useSaveBibliography() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: BibliographyInput) => put<BibliographyEntryView[]>("/api/bibliography", body),
    onSuccess: (saved) => qc.setQueryData(KEY, saved),
  });
}
